__turbopack_context__.v({
  "CustomerReviewContent": "customer-review-module__VUUAoW__CustomerReviewContent",
  "CustomerReviewImg": "customer-review-module__VUUAoW__CustomerReviewImg",
});
